import { render, staticRenderFns } from "./orderSummary.vue?vue&type=template&id=20c2cbd5&scoped=true"
import script from "./orderSummary.vue?vue&type=script&lang=js"
export * from "./orderSummary.vue?vue&type=script&lang=js"
import style0 from "./orderSummary.vue?vue&type=style&index=0&id=20c2cbd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c2cbd5",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SingleSelect: require('/vercel/path0/components/ui/singleSelect.vue').default,Field: require('/vercel/path0/components/ui/field.vue').default})
